var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('i-input',{attrs:{"size":"small","icon":_vm.icon,"placeholder":_vm.placeholder},on:{"on-click":_vm.handleClick},model:{value:(_vm.currentQuery),callback:function ($$v) {_vm.currentQuery=$$v},expression:"currentQuery"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }